export default {
    name: 'PrePlansPage',
    
    computed: {
        documents() {
            return this.$store.getters.getDocumentsList('preplans');
        },
        missing() {
            return this.$store.getters.getMissingDocuments;
        },
        online() {
            return this.$store.getters.getOffline;
        },
        cached() {
            return this.$store.getters.getDocumentCache;
        }
    },

    methods: {
        can_show(document) {
            if (this.online) { return true; }
            if (this.cached.includes(String(document.id))) { return true; }
            return false;
        } 
    },

    created() {
        this.$store.dispatch('fetchAnnotations');
        this.$store.commit('setMenuItems', this.documents);
        this.$store.commit('setMenuDetails', { title: 'Pre Plans', slug: 'pre-plans', back_url: '/action' });
    }
};